const detachableTrailers = [
  {
    model: "DT540 DECK",
    cargo_dimensions: "540 X 244 X 14 CM",
    total_length: "",
    axles: "",
    maximum_authorized_mass: "",
    own_mass: "",
    loading_capacity: "185 KG",
    price: 1300,
    newPrice: null,
    img: "images/detachable-decks-2026/TH450.jpg",
    imgAlt: "detachable deck",
    onlyDeck: true
  },
  {
    model: "DT600 DECK",
    cargo_dimensions: "600 X 244 X 14 CM",
    total_length: "",
    axles: "",
    maximum_authorized_mass: "",
    own_mass: "",
    loading_capacity: "203 KG",
    price: 1350,
    newPrice: null,
    img: "images/detachable-decks-2026/TH450.jpg",
    imgAlt: "detachable deck",
    onlyDeck: true
  },
  {
    model: "DT660 DECK",
    cargo_dimensions: "660 X 244 X 14 CM",
    total_length: "",
    axles: "",
    maximum_authorized_mass: "",
    own_mass: "",
    loading_capacity: "224 KG",
    price: 1400,
    newPrice: null,
    img: "images/detachable-decks-2026/TH450.jpg",
    imgAlt: "detachable deck",
    onlyDeck: true
  },
  {
    model: "DT720 DECK",
    cargo_dimensions: "720 X 244 X 18 CM",
    total_length: "",
    axles: "",
    maximum_authorized_mass: "",
    own_mass: "",
    loading_capacity: "270 KG",
    price: 1450,
    newPrice: null,
    img: "images/detachable-decks-2026/TH450.jpg",
    imgAlt: "detachable deck",
    onlyDeck: true
  },
  {
    model: "DT780 DECK",
    cargo_dimensions: "780 X 244 X 18 CM",
    total_length: "",
    axles: "",
    maximum_authorized_mass: "",
    own_mass: "",
    loading_capacity: "287 KG",
    price: 1500,
    newPrice: null,
    img: "images/detachable-decks-2026/TH450.jpg",
    imgAlt: "detachable deck",
    onlyDeck: true
  },
  {
    model: "DT840 DECK",
    cargo_dimensions: "840 X 244 X 18 CM",
    total_length: "",
    axles: "",
    maximum_authorized_mass: "",
    own_mass: "",
    loading_capacity: "309 KG",
    price: 1550,
    newPrice: null,
    img: "images/detachable-decks-2026/TH450.jpg",
    imgAlt: "detachable deck",
    onlyDeck: true
  }
];

export default detachableTrailers;
